import React from "react";
import _ from "lodash";
import ReactTable from "react-table";
import { Column, Table } from "react-virtualized";
import * as moment from "moment";

import history from "../../history";

import Draggable from "react-draggable";
import swal from "sweetalert";
import convert from "xml-js";
import Modal from "react-responsive-modal";
import "./itemDetailsList.css";
import "react-virtualized/styles.css";
import spinner from "../../icons/spinner.svg";
import content from "./content";

import { langProp, productIDProp } from "model/component-props";
import { connectProps } from "store";
import "react-table/react-table.css"

const TOTAL_WIDTH = 1200;

class ItemDetailsList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      multipleReceipts: [],
      sortBy: "No",
      sortByMultipleReceipts: "Variant_Code",
      sortDirection: "ASC",
      sortDirectionMultiple: "ASC",
      widths: {
        Item_No: 0.35,
        Code: 0.5,
        Description_2: 0.45,
        GrossRequirement: 0.55,
        ScheduledRcpt: 0.55,
        ExpectedRcptDate: 0.45,
        Inventory: 0.35,
        ProjAvailBalance: 0.47
      },
      open: false,
      listOfVariantCodes: []
    };

    this.escFunction = this.escFunction.bind(this);
    this._cellRenderer = this._cellRenderer.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      history.goBack();
    }
  }

  componentDidMount() {
    let dataAsJson = {};
    document.addEventListener("keydown", this.escFunction, false);

    const cardID = this.props.productIDProp;
    fetch(`${process.env.REACT_APP_NODE_SERVER}/getDetails`, {
      crossDomain: true,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ cardID: cardID })
    })
      .then(response => response.text())
      .then(str => {
        dataAsJson = convert.xml2json(str, { compact: true, spaces: 4 });
        return JSON.parse(dataAsJson);
      })
      .then(data => {
        this.setState({ data });

        const simplifiedData =
          data &&
          _.castArray(
            _.get(data, [
              "Soap:Envelope",
              "Soap:Body",
              "ReadMultiple_Result",
              "ReadMultiple_Result",
              "ItemCharacteristics"
            ])
          );
        const beautifiedData = _.map(simplifiedData, simple =>
          _.reduce(
            simple,
            (r, value, key) => ({
              ...r,
              [key]: value["_text"]
            }),
            {}
          )
        );

        let listOfVariantCodes = [];
        for (let i = 0; i < beautifiedData.length; i++) {
          if (beautifiedData[i].MultipleReceiptsExist === "true") {
            listOfVariantCodes.push(beautifiedData[i].Code);
          }
        }

        console.log("liiiiiist", listOfVariantCodes);
        this.setState({
          listOfVariantCodes
        });
      });
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  sort = ({ sortBy, sortDirection }) => {
    this.setState({
      sortBy,
      sortDirection
    });
  };

  sortMultipleReceipts = ({
    sortByMultipleReceipts,
    sortDirectionMultiple
  }) => {
    this.setState({
      sortByMultipleReceipts,
      sortDirectionMultiple
    });
  };

  addDefaultSrc(ev) {
    ev.target.src = `${process.env.REACT_APP_NODE_SERVER}/notfound.png`;
    ev.target.onerror = null;
  }

   date = (previousdate) => {
     const date = previousdate.substring(0, 10)
    if (date === "0001-01-01") {
      return "";
    } else {
      var newDate = moment(date).format("DD/MM/YYYY");
      return newDate;
    }
  }


  _cellRenderer({
    cellData,
    rowData,
  }) {
    if (this.state.listOfVariantCodes.includes(rowData.Code)) {
      return (
        <span
          onClick={() => this.openModal(rowData.Code)}
          className="expectedDate"
        >
          {cellData}
        </span>
      );
    } else {
      return <span>{cellData}</span>;
    }
  }


  openModal = (code) => {
    const promise = new Promise((resolve, reject) => {
      resolve(
        fetch(
          `${process.env.REACT_APP_NODE_SERVER}/B2BExpectedPurchOrderLines`,
          {
            crossDomain: true,
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              no: this.props.productIDProp,
              variant: `${code}`
            })
          }
        )
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("HTTP error " + response.status);
        })
        .then(data => {
          console.log(data);
          if ("error" in data) {
            swal({
              icon: "error",
              text: data.error.message
            });
          } else {
            this.setState({ multipleReceipts: data.value });
            console.log(data.value);
          }
          })
      );
    });

    promise.then(() => {
      this.setState({
        open: true
      });
    });
  };

  render() {
    if (!this.state.data) {
      return (
        <div className="container-customersList">
          <img src={spinner} alt="spinner" className="spinner" />
        </div>
      );
    }
    const {
      data,
      widths,
    } = this.state;
    const { langProp } = this.props;
    const simplifiedData =
      data &&
      _.castArray(
        _.get(data, [
          "Soap:Envelope",
          "Soap:Body",
          "ReadMultiple_Result",
          "ReadMultiple_Result",
          "ItemCharacteristics"
        ])
      );
    const beautifiedData = _.map(simplifiedData, simple =>
      _.reduce(
        simple,
        (r, value, key) => ({
          ...r,
          [key]: value["_text"]
        }),
        {}
      )
    );

    console.log(beautifiedData);
    const tempList = _.sortBy([...beautifiedData], d => {
      return this.state.sortBy === "GrossRequirement" ||
        this.state.sortBy === "ScheduledRcpt" ||
        this.state.sortBy === "Inventory" ||
        this.state.sortBy === "ProjAvailBalance"
        ? parseFloat(d[this.state.sortBy])
        : d[this.state.sortBy];
    });

    const list =
      this.state.sortDirection === "DESC" ? tempList.reverse() : tempList;

    return (
      <div>
        <button onClick={history.goBack} className="escapeButton">
          X
        </button>
        <p style={{textAlign: 'center'}}>{content[langProp].message}</p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Table
            style={{
              margin: "20px",
              backgroundColor: "white",
              overflowX: "scroll"
            }}
            rowStyle={{ border: "0.5px grey" }}
            width={TOTAL_WIDTH}
            height={200}
            headerHeight={35}
            headerStyle={{ color: "white" }}
            rowHeight={30}
            rowCount={list.length}
            rowGetter={({ index }) => list[index]}
            sortBy={this.state.sortBy}
            sortDirection={this.state.sortDirection}
            sort={this.sort}
          >
            <Column
              headerRenderer={this.headerRenderer}
              label={content[langProp].ID}
              dataKey="Item_No"
              width={widths.Item_No * TOTAL_WIDTH}
            />

            <Column
              headerRenderer={this.headerRenderer}
              label={content[langProp].ColorCode}
              dataKey="Code"
              width={widths.Code * TOTAL_WIDTH}
            />

            <Column
              headerRenderer={this.headerRenderer}
              label={content[langProp].Color}
              dataKey={this.props.langProp === 'GR' ? 'Description_2' : 'ENUDescription'}
              width={widths.Description_2 * TOTAL_WIDTH}
            />

            <Column
              headerRenderer={this.headerRenderer}
              style={{ textAlign: "right", paddingRight: "10px" }}
              //headerStyle={{ textAlign: "right", paddingRight: "10px" }}
              label={content[langProp].GrossReq}
              dataKey="GrossRequirement"
              cellDataGetter={({ rowData }) =>
                parseFloat(rowData.GrossRequirement)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              width={widths.GrossRequirement * TOTAL_WIDTH}
            />

            <Column
              headerRenderer={this.headerRenderer}
              cellRenderer={this._cellRenderer}
              style={{ textAlign: "right", paddingRight: "20px" }}
              //headerStyle={{ textAlign: "right", paddingRight: "20px" }}
              label={content[langProp].ScheduledRcpt}
              dataKey="ScheduledRcpt"
              cellDataGetter={({ rowData }) =>
                parseFloat(rowData.ScheduledRcpt)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              width={widths.ScheduledRcpt * TOTAL_WIDTH}
            />

            <Column
              headerRenderer={this.headerRenderer}
              cellRenderer={this._cellRenderer}
              label={content[langProp].ExpectedDate}
              dataKey="ExpectedRcptDate"
              cellDataGetter={({ rowData }) =>
                rowData.ExpectedRcptDate !== "0001-01-01"
                  ? rowData.ExpectedRcptDate
                  : ""
              }
              width={widths.ExpectedRcptDate * TOTAL_WIDTH}
            />

            <Column
              headerRenderer={this.headerRenderer}
              style={{ textAlign: "right" }}
              //headerStyle={{ textAlign: "right" }}
              label={content[langProp].Inventory}
              dataKey="Inventory"
              cellDataGetter={({ rowData }) =>
                parseFloat(rowData.Inventory)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              width={widths.Inventory * TOTAL_WIDTH}
            />

            <Column
              headerRenderer={this.headerRenderer}
              style={{ textAlign: "right", paddingRight: "20px" }}
              //headerStyle={{ textAlign: "right", paddingRight: "20px" }}
              label={content[langProp].ProjAvailBalance}
              dataKey="ProjAvailBalance"
              cellDataGetter={({ rowData }) =>
                parseFloat(rowData.ProjAvailBalance)
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              width={widths.ProjAvailBalance * TOTAL_WIDTH}
            />
          </Table>
        </div>

        <div className="image-container">
          <img
            className="image-item"
            src={`${process.env.REACT_APP_NODE_SERVER}/${this.props.productIDProp}.JPG`}
            alt="item"
            onError={this.addDefaultSrc}
          ></img>
        </div>
        <p style={{textAlign: 'center', fontSize: '14px'}}>Visualization of colour tones may be diverged</p>
        <Modal
          open={this.state.open}
          onClose={this.onCloseModal}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          showCloseIcon={false}
          center
          styles={{
            modal: {
              maxWidth: "650px"
            }
          }}
        >
          <div style={{ marginTop: "20px", width: "653px" }}>
          <span>{this.props.langProp === 'EN' ? 'Expected Receipts' : 'Αναμενόμενες Παραλαβές'}</span>
            <button
              onClick={() => this.setState({ open: false })}
              className="escapeButtonOnRcptModal"
            >
              X
            </button>

            <div style={{ paddingTop: "10px" }}>
            <ReactTable
              style={{ height: 300 }}
              data={this.state.multipleReceipts || []}
              showPagination={false}
              minRows={1}
              getTheadThProps={() => {
                return {
                  style: {
                    fontSize: "13px",
                    backgroundColor: '#123C69',
                    color: 'white',
                    fontWeight: 'bold'
                  }
                }
              }}
              getTrProps={(state, rowInfo, column, instance) => {
                if (rowInfo && rowInfo.row) {
                  return {
                    style: {
                      background:
                        rowInfo.index === this.state.selected
                          ? "#D5F5FE"
                          : "white"
                    }
                  };
                } else {
                  return {};
                }
              }}
              columns={[
                {
                  columns: [
                    {
                      Header: content[langProp].Variant,
                      id: "Variant_Code",
                      accessor: "Variant_Code",
                      width: 200
                    },
                    {
                      Header: content[langProp].Expected,
                      id: "Expected_Receipt_Date",
                      accessor: d => this.date(d.Expected_Receipt_Date),
                      width: 200
                    },
                    {
                      Header: content[langProp].Quantity,
                      id: "Quantity",
                      accessor: "Quantity",
                      getProps: () => {
                        return {
                          style: {
                            textAlign: "right"
                          }
                        };
                      },
                      width: 250
                    },
                  ]
                }
              ]}
              />
              </div>
              </div>
        </Modal>
      </div>
    );
  }

  headerRenderer = ({
    columnData,
    dataKey,
    disableSort,
    label,
    sortBy,
    sortDirection
  }) => {
    return (
      <React.Fragment key={dataKey}>
        <div className="ReactVirtualized__Table__headerTruncatedText">
          {label}
        </div>
        <Draggable
          axis="x"
          defaultClassName="DragHandle"
          defaultClassNameDragging="DragHandleActive"
          onDrag={(event, { deltaX }) =>
            this.resizeRow({
              dataKey,
              deltaX
            })
          }
          position={{ x: 0 }}
          zIndex={999}
        >
          <span className="DragHandleIcon">|</span>
        </Draggable>
      </React.Fragment>
    );
  };

  resizeRow = ({ dataKey, deltaX }) =>
    this.setState(prevState => {
      const prevWidths = prevState.widths;
      const percentDelta = deltaX / TOTAL_WIDTH;

      return {
        widths: {
          ...prevWidths,
          [dataKey]: prevWidths[dataKey] + percentDelta
          //[nextDataKey]: prevWidths[nextDataKey] - percentDelta
        }
      };
    });
}

export default connectProps(productIDProp, langProp)(ItemDetailsList);



// WEBPACK FOOTER //
// ./src/components/itemdetailslist/ItemDetailsList.js